import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import VerticalNavBar from "../VerticalNavBar";

function MonthlyLearning(props) {
  return (
    <>
      <Container fluid className="project-section">
        <Particle />
        <Col>
          <Row>
            <VerticalNavBar
              setIsAuthenticated={props.setIsAuthenticated}
              setLearning={props.setLearning}
            />
          </Row>
        </Col>
        <Container>
          <h1>hsagdgshdjf</h1>
        </Container>
      </Container>
    </>
  );
}

export default MonthlyLearning;
